import Repository from './Repository';

const resource = 'api/kurihashiKakuho';

export default {
  get(): Promise<any> {
    return Repository.get(resource);
  },
};
